import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from '@emailjs/browser';

const FormVideoHelpFr = () => {
    const [choiceOS, setChoiceOS] = useState('- Choisir -');
    const [deviceType, setDeviceType] = useState('- Choisir -');
    const [deviceAutre, setDeviceAutre] = useState('');
    const [choiceProv, setChoiceProv] = useState('- Choisir -');
    const [connection, setConnection] = useState('');
    const [autreOS, setAutreOS] = useState('');
    const [versionOS, setVersionOS] = useState('');
    const [browser, setBrowser] = useState('');
    const [browserAutre, setBrowserAutre] = useState('');
    const [city, setCity] = useState('');
    const [speed, setSpeed] = useState('');
    const [errors, setErrors] = useState('');
    const [errorDetails, setErrorDetails] = useState('');
    const [vod, setVod] = useState('');
    const [live, setLive] = useState('');
    const [cpacApp, setCpacApp] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [name, setName] = useState('');
    const [messageSent, setMessageSent] = useState();
    const [messageError, setMessageError] = useState();
    const [captchaValue, setCaptchaValue] = useState(null); 
    const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY;  
    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);  
        
    const renderTextField = (inputData, value, onChange) => {
        return (
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>{inputData.required}</span> : ''}</label>
            <div className='input_container input_container_text'>
                <input name={inputData.name} 
                id={inputData.id} 
                type={inputData.type} 
                value={ value } 
                className='medium' 
                aria-invalid="false" 
                aria-required={inputData.ariaRequired}
                aria-describedby={inputData.description}
                onChange={(e) => onChange(e.target.value)}>
                </input>
                {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
            </div>
            </>
        );
    }

    const renderTextArea = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_textarea'>
                <textarea name={inputData.name} 
                id={inputData.id} 
                className='textarea medium' 
                value={value} 
                aria-invalid="false" rows='10' cols='50'
                onChange={(e) => onChange(e.target.value)}/>
            </div>
            </>
        );
    }

    const renderEmailField = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_email'>
                <input 
                name={inputData.name} 
                id={inputData.id} 
                type='email' 
                value={value} 
                className='medium' 
                aria-required="true" aria-invalid="false" aria-describedby="field_description_email"
                onChange={(e) => onChange(e.target.value)}>
                </input>
            </div>
            <div className={`sp_field_description ${isEmail(value) ? "" : "invalid"}`} id="field_description_email">{!isEmail(value) ? inputData.description : "Merci"}</div>
            </>
        );
    }

    const renderCheckRadio = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label'>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div aria-activedescendant={inputData.choices[0].value} name={value} className='input_container input_container_checkbox' role={inputData.type === 'radio' ? "radiogroup" : "checkbox"} tabIndex="1">
            {inputData.choices.map(({type, name, value, label}, i) => <div key={`${inputData.name}-${i}`}><input name={name} type={type} className={type} value={value} id={type === 'radio' ? value : name} onChange={(e) => onChange(e.target.value)}></input><label htmlFor={type === 'radio' ? value : name}>{label}</label></div>)}
            </div>
            </>
        )
    }

    const renderDropdown = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_select'>
                    <select 
                        name={inputData.name} 
                        id={inputData.id} 
                        className='medium field_select' 
                        aria-required="true" 
                        aria-invalid="false"
                        value={ value }
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {inputData.option.map(({value, label}, i) => <option key={`${inputData.name}-${i}`} value={value}>{label}</option>)}
                    </select>
                </div>
            </>
        )
    }

    const renderChoiceOs = () => {
        const inputData = {
            name: 'operating-system-choice',
            id: 'OSselector',
            label: 'Type de système d\'exploitation',
            option: [
                {label: '- Choisir -', value: '- Choisir -'},
                {label: 'Windows', value: 'Windows'},
                {label: 'Mac', value: 'Mac'},
                {label: 'Linux', value: 'Linux'},
                {label: 'Apple iOS - iPad / iPhone', value: 'Apple iOS - iPad / iPhone'},
                {label: 'Andriod', value: 'Andriod'},
                {label: 'Autre', value: 'Autre'},
            ],
            required: true,
        };

        return renderDropdown(inputData, choiceOS, setChoiceOS);
    }

    const renderAutreOS = () => {
        const inputData = {
            name: 'autreOS',
            id: 'otherOS',
            label: 'Système d\'exploitation - Autre',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_OSother',
            message: 'Si votre système d\'exploitation ne figure pas dans la liste, veuillez indiquer le nom de votre système d\'exploitation.'
        }
        return renderTextField(inputData, autreOS, setAutreOS);
    }

    const renderVersionOS = () => {
        const inputData = {
            name: 'Operating-system-version',
            id: 'OSversion',
            label: 'La version de système d\'exploitation',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_OSversion',
            message: 'Si vous connaissez la version de votre système d\'exploitation, veuillez l\'indiquer ici.'
        }
        return renderTextField(inputData, versionOS, setVersionOS);
    }

    const renderDeviceType = () => { 
        const inputData = {
            name: 'device-type',
            id: 'deviceType',
            label: 'Type d\'appareil',
            option: [
                {label: '- Choisir -', value: '- Choisir -'},
                {label: 'Ordinateur de bureau', value: 'Desktop'},
                {label: 'Ordinateur portable', value: 'Laptop'},
                {label: 'Tablette', value: 'Tablet'},
                {label: 'Téléphone', value: 'Phone'},
                {label: 'Télévision intelligente', value: 'Smart TV'},
                {label: 'Console de jeux', value: 'Game Console'},
                {label: 'Autre', value: 'Autre'},
            ],
            required: true,
        };

        return renderDropdown(inputData, deviceType, setDeviceType);
    }

    const renderAutreDevice = () => {
        const inputData = {
            name: 'otherDevice',
            id: 'deviceOther',
            label: 'Type d\'appareil - Autre',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_deviceOther',
            message: 'Si votre type d\'appareil ne figure pas dans la liste, veuillez indiquer le type d\'appareil que vous utilisez.'
        }
        return renderTextField(inputData, deviceAutre, setDeviceAutre);
    }

    const renderBrowser = () => {
        const inputData = {
            name: 'browser',
            id: 'browserSelect',
            label: 'Type de navigateur',
            required: true,
            option: [
                {label: '- Choisir -', value: '- choisir -'},
                {label: 'Edge', value: 'Edge'},
                {label: 'Firefox', value: 'Firefox'},
                {label: 'Safari', value: 'Safari'},
                {label: 'Chrome', value: 'Chrome'},
                {label: 'Autre', value: 'Autre'},
            ]
        };

        return renderDropdown(inputData, browser, setBrowser);
    }

    const renderBrowserAutre = () => {
        const inputData = {
            name: 'browser_autre',
            id: 'other-browser',
            label: 'Navigateur - Autre',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_browserOther',
            message: 'Si votre navigateur Web ne figure pas dans la liste, veuillez indiquer le nom de votre navigateur.'
        }
        return renderTextField(inputData, browserAutre, setBrowserAutre);
    }

    const renderCity = () => {
        const inputData = {
            name: 'city',
            id: 'location',
            label: 'Votre ville',
            type: 'text',
            value: '',
            required: true,
            ariaRequired: 'true',
            description: 'field_description_city',
            message: 'Veuillez indiquer votre emplacement.'
        }
        return renderTextField(inputData, city, setCity);
    }

    const renderChoiceProv = () => {
        const inputData = {
            name: 'province-territory',
            id: 'province',
            label: 'Votre province / territoire',
            option: [
                {label: '- Choisir -', value: 'Select your Province or Territory'},
                {label: 'Colombie-britannique', value: 'Colombie-britannique'},
                {label: 'Alberta', value: 'Alberta'},
                {label: 'Saskatchewan', value: 'Saskatchewan'},
                {label: 'Manitoba', value: 'Manitoba'},
                {label: 'Ontario', value: 'Ontario'},
                {label: 'Québec', value: 'Québec'},
                {label: 'Nouveau-Brunswick', value: 'Nouveau-Brunswick'},
                {label: 'Île-du-Prince-Édouard', value: 'Île-du-Prince-Édouard'},
                {label: 'Nouvelle-Écosse', value: 'Nouvelle-Écosse'},
                {label: 'Terre-Neuve-et-Labrador', value: 'Terre-Neuve-et-Labrador'},
                {label: 'Nunavut', value: 'Nunavut'},
                {label: 'Territoires du Nord-Ouest', value: 'Territoires du Nord-Ouest'},
                {label: 'Yukon', value: 'Yukon'},
            ],
            required: true,
        };

        return renderDropdown(inputData, choiceProv, setChoiceProv);
    }

    const renderConnection = () => { //CHECK FOR TRANSLATION
        const inputData = {
            name: 'internet-connection',
            id: 'connection',
            label: 'Type de connexion',
            required: true,
            option: [
                {label: '- Choisir -', value: '- choisir -'},
                {label: 'Modem câble', value: 'Cable'},
                {label: 'Fibre optique', value: 'Fibre'},
                {label: 'Satellite', value: 'Satellite'},
                {label: 'Sans fil fixe', value: 'Fixed Wireless'},
                {label: 'Mobile', value: 'Mobile'},
                {label: 'DSL (Digital Subscriber Line - ligne d\'accès numérique)', value: 'DSL'},
            ]
        };

        return renderDropdown(inputData, connection, setConnection);
    }

    const renderSpeed = () => {
        const inputData = {
            name: 'connection-speed',
            id: 'speed',
            label: 'Vitesse de connexion (si vous les connaissez)',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_speed',
            message: 'Si vous connaissez votre vitesse de connexion, veuillez l\'indiquer ici.'
        }
        return renderTextField(inputData, speed, setSpeed);
    }

    const renderErrors = () => {
        const inputData = {
            name: 'errors',
            id: 'errorsRB',
            label: 'Y a-t-il des messages d’erreur ?',
            type: 'radio',
            choices: [
                {type: 'radio', name: 'errors', label: 'Oui', value: 'errors-yes'},
                {type: 'radio', name: 'errors', label: 'Non', value: 'errors-no'},                
            ],
            required: false,
        };

        return renderCheckRadio(inputData, errors, setErrors);
    }

    const renderErrorDetails = () => {
        const inputData = {
            name: 'error_details',
            id: 'errorDetails',
            label: 'Veuillez expliquer en détails les difficultés que vous éprouvez.',
            required: false,
        }
        return renderTextArea(inputData, errorDetails, setErrorDetails);
    }

    const renderLive = () => {
        const inputData = {
            name: 'live',
            id: 'liveURL',
            label: 'Pour les flux direct',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_live',
            message: 'Veuillez copier et coller l\'URL du flux direct qui pose problème.'
        };

        return renderTextField(inputData, live, setLive);
    }

    const renderVod = () => {
        const inputData = {
            name: 'vod',
            id: 'vodURL',
            label: 'Pour le service vidéo sur demande',
            type: 'text',
            value: '',
            required: false,
            ariaRequired: 'false',
            description: 'field_description_VOD',
            message: 'Veuillez copier et coller l\'URL de la vidéo qui pose problème.'
        }
        return renderTextField(inputData, vod, setVod);
    }

    const renderCpacApp = () => {
        const inputData = {
            name: 'CPAC app',
            id: 'cpacApp',
            label: 'Le problème concerne-t-il notre application Télé CPAC Partout ?',
            type: 'checkbox',
            choices: [
                {type: 'checkbox', name: 'cpac_app', label: 'Oui', value: 'yes'},
            ],
            required: false,
        };

        return renderCheckRadio(inputData, cpacApp, setCpacApp);
    }

    const renderName = () => {
        const inputData = {
            name: 'votre-nom',
            id: 'name',
            label: 'Nom',
            type: 'text',
            value: '',
            ariaRequired: 'false',
            description: 'field_description_name',
            message: 'Votre nom est facultatif.',
            required: false,
        }
        return renderTextField(inputData, name, setName);
    }

    const renderEmailDetails = () =>{
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            label: 'Courriel',
            required: true,
            description: 'Veuillez fournir votre adresse électronique',
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress);
    }

    const captchaRef = useRef(null);
    
    const onReCaptchaChange = (value) => {
        setCaptchaValue(value);
    }

    const buttonDisabled = (captchaValue) => {
        return (
            !captchaValue ? "disabled" : ""
        )
    }

    const handleSubmit = (e) => {
    e.preventDefault();
    captchaRef.current.reset();
        const templateParams = { 
            senderLanguage: "Français",
            senderName: name,
            senderEmail: emailAddress, 
            senderCity: city, 
            senderProvince: choiceProv,
            senderOS: choiceOS === "Autre" ? autreOS : choiceOS, 
            senderOSversion: versionOS,
            senderDeviceType: deviceType === "Autre" ? deviceAutre : deviceType,
            senderBrowser: browser === "Autre" ? browserAutre : browser,
            senderConnectType: connection,
            senderConnectSpeed: speed,
            senderErrors: errors,
            senderErrorDetails: errorDetails,
            senderLiveStreams: live,
            senderVOD: vod,
            senderApp: cpacApp
        };
        emailjs.send('outlook_service', 'video_help_template', templateParams, process.env.REACT_APP_EMAILJS_KEY)
            .then(function() {
                setMessageSent(true);
                e.target.reset(); // reset the form
            }, function(error) {
                setMessageError(true);
            });
    }
    
    return (
        <>
        {       // MESSAGES NEED TRANSLATION
            messageSent ? <h2 className='form_wrapper message_success'>Nous vous remercions de votre commentaire.</h2> : messageError ? <h2 className='form_wrapper message_fail'>Désolé, il y a eu un problème avec votre envoi. Prière de réessayer plus tard.</h2> :
            <div id="form_wrapper" className="form_wrapper">
                <form onSubmit={(e) => handleSubmit(e)}>
                    <div className="form_body">
                        { renderChoiceOs() }
                        { choiceOS === 'Autre' ? renderAutreOS() : '' }
                        { renderVersionOS() }
                        { renderDeviceType() }
                        { deviceType === 'Autre' ? renderAutreDevice() : ''}
                        { renderBrowser() }
                        { browser === 'Autre' ? renderBrowserAutre() : '' }
                        { renderCity() }
                        { renderChoiceProv() }
                        { renderConnection() }
                        { renderSpeed() }
                        { renderErrors() }
                        { renderErrorDetails() }
                        { renderLive() }
                        { renderVod() }
                        { renderCpacApp() }
                        { renderName() }
                        { renderEmailDetails() }
                    </div>
                    <ReCAPTCHA sitekey={captchaKey} ref={captchaRef} onChange={onReCaptchaChange} hl="fr" />
                    <div className='form_footer left_label'>
                        <button type="submit" name='submit' value='soumettre' className="btn--primary" disabled={buttonDisabled(captchaValue)}>Soumettre</button>
                    </div>
                </form>
            </div>
        }
        </>
    )
}

export default FormVideoHelpFr;